import { FormField, GroupField } from "../../data-model/pharmaPaFormModel";
import { AddMore } from "../../svg/add-more";
import RenderSingleCardForFormConfig from "./renderSingleCardForFormConfig";

const RenderGroupFieldForFormConfig = ({
  field,
  parentKey,
  onAddField,
  onDeleteField,
  onEditField,
}: {
  field: GroupField;
  parentKey?: string;
  onAddField: (parentKey: string) => void;
  onDeleteField: (key: string) => void;
  onEditField?: (
    parentKey?: string,
    field?: FormField,
    renderIndex?: number,
  ) => void;
}) => {
  const groupedFields = field.fields;
  return (
    <>
      {groupedFields.map((field, index) => (
        <div
          key={field.key}
          className={`single-row__container ${
            index === groupedFields.length - 1 ? "mb-0" : "mb-4"
          }`}
        >
          <RenderSingleCardForFormConfig
            field={field as GroupField}
            renderIndex={index}
            parentKey={parentKey}
            onAddField={onAddField}
            onDeleteField={onDeleteField}
            onEditField={onEditField ?? undefined}
          />
        </div>
      ))}
      <div
        className="add-button mb-2 ml-2 flex items-center gap-1 text-tiny font-semibold text-tertiaryBlue-4 hover:cursor-pointer hover:text-tertiaryBlue-5"
        onClick={() => {
          onAddField(parentKey ?? "");
        }}
      >
        <AddMore />
        Add Field
      </div>
    </>
  );
};

export default RenderGroupFieldForFormConfig;
